import { Link } from 'react-router';
import { ArrowLeft } from 'lucide-react';

export interface BackLinkProps {
  to: string;
  label: string;
}

/** Lien de retour à la liste, au-dessus d'une fiche */
export function BackLink({ to, label }: BackLinkProps) {
  return (
    <Link to={to} className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 mb-4">
      <ArrowLeft className="w-4 h-4" />
      {label}
    </Link>
  );
}
